import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import useRefreshToken from "../../hooks/useRefreshToken";
import useAuth from "../../hooks/useAuth";
import SplashScreen from "../../Componet/SplashScreen";

const PersistLogin = () => {
    const [isLoading, setIsLoading] = useState(true);
    const refresh = useRefreshToken();
    const { auth } = useAuth();

    useEffect(() => {
        let isMounted = true;

        const verifyRefreshToken = async () => {
            try {
                await refresh();
            } catch (err) {
                console.error(err); // no valid session — fine, PrivateRoutes will redirect
            } finally {
                isMounted && setIsLoading(false);
            }
        };

        !auth?.user?.access_token ? verifyRefreshToken() : setIsLoading(false);

        return () => { isMounted = false; };
    }, []);

    // return isLoading ? <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>  : <Outlet />;
    return isLoading ? <SplashScreen/>  : <Outlet />;
};

export default PersistLogin;